import React from 'react';
import { Modal, ModalProps } from 'antd';
import { PopupProps } from 'react-popup-manager/dist/src';
import classNames from 'classnames';
import './index.scss';

const cx = classNames.bind('./index.scss');

export interface ModalWrapperProps extends PopupProps, ModalProps {
  showBorder?: boolean;
}

const ModalWrapper = ({
  showBorder = true,
  children,
  isOpen,
  centered = true,
  destroyOnClose = true,
  closable = false,
  ...props
}: React.PropsWithChildren<ModalWrapperProps>): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Modal
      wrapClassName={cx(!showBorder && 'non-border-modal', 'custom-modal')}
      open={isOpen}
      centered={centered}
      destroyOnClose={destroyOnClose}
      closable={closable}
      {...props}
      footer={null}
      maskClosable={!closable}
      keyboard={true}   
    >
      {children}
    </Modal>
  );
};

export default React.memo(ModalWrapper);
